export default __webpack_public_path__ + "static/media/school-white.e0e42d47.svg";